import setMockNotificationCookie from '../mocks/NotificationCookie';
import { getCookie } from './Cookie';
import parseJSONSGracefully from './parseJSONSGracefully';
import CookieNames from '../constants/CookieNames';

/**
 * For available attributes, see the backend cookie contract:
 *  VeevaID/src/main/java/veeva/ecm/veevaid/util/Notification.java
 *
 *  @returns {NotificationCookie}
 */
const useNotificationCookie = () => {
    // USE_MOCK_APIS is defined by Webpack based on the environment flag "USE_MOCK_APIS".
    // eslint-disable-next-line no-undef
    if (USE_MOCK_APIS) {
        return setMockNotificationCookie();
    }

    const cookie = getCookie(CookieNames.NOTIFICATION);
    return parseJSONSGracefully(cookie);
};

export default useNotificationCookie;
